import type { UcBenefitStatsSection } from '../../../lib/useCaseQueries';
import { UseCaseBand } from '../primitives';

type UcBenefitStatsSectionProps = {
  data: UcBenefitStatsSection;
  tone: 'light' | 'dark';
};

export function UcBenefitStatsSection({ data, tone }: UcBenefitStatsSectionProps) {
  return (
    <UseCaseBand tone={tone} id="benefits" className="uc-benefit-stats">
      {data.eyebrow && <div className="uc-shift-eyebrow reveal">{data.eyebrow}</div>}
      {data.cells && data.cells.length > 0 && (
        <div className="uc-shift-grid reveal">
          {data.cells.map((cell) => (
            <div key={`${cell.value}-${cell.label}`} className="uc-shift-cell">
              <div className="uc-shift-n">{cell.value}</div>
              <div className="uc-shift-label">{cell.label}</div>
              {cell.detail && <p className="uc-shift-detail">{cell.detail}</p>}
            </div>
          ))}
        </div>
      )}
    </UseCaseBand>
  );
}
